const useGeoLocation = () => {
  const geoLocationData = { countryCode: 'IN' };
  return { geoLocationData };
};

export default useGeoLocation;
